import React from 'react'
import PropTypes from 'prop-types'
import {
  View, Image, Text, StyleSheet
} from '@react-pdf/renderer'
import { Line } from './Line.js'

// Create styles
const styles = StyleSheet.create({
  container: {
    display: 'flex',
    alignItems: 'center',
    padding: 24,
  },
  image: {
    width: '30vw',
    height: '10vh',
    textAlign: 'center',
  },
  name: {
    marginTop: 8,
  },
  line: {
    width: '70%',
  },
})

// Create Document Component
export const Signature = ({ image, beneficiaryName }) => (
  <View style={styles.container} wrap={false}>
    <Image src={image} style={styles.image} />
    <View style={styles.line}>
      <Line lineColor="#7A899F" />
    </View>
    <Text style={styles.name}>
      {' '}
      {beneficiaryName}
      {' '}
    </Text>
  </View>
)

Signature.propTypes = {
  image: PropTypes.string.isRequired,
  beneficiaryName: PropTypes.string.isRequired,
}
